<template>
  <v-container fluid class="mt-4 pa-0">
    <v-row>
      <v-col cols="12" md="12">
        <el-autocomplete
          required
          :items="turtasRusisList"
          itemvalue="value"
          itemtext="text"
          label="Turto rūšis"
          tooltip="Paieška. Turtas. Turto rūšis"
          v-model="mainData.tur_rusis"
          :readonly="isIsrasasNtr"
          autofocus
        />
      </v-col>
      <template v-if="mainData.tur_rusis">
        <v-col cols="12" :md="isVpb ? 12 : 6" v-if="showSearch1">
          <el-text-field
            :required="requiredSearch1"
            :key="search1Key"
            :label="search1"
            :tooltip="search1Tooltip"
            v-mask="mask1"
            :placeholder="placeholder1"
            v-model="mainData[search1Field]"
          />
        </v-col>
        <v-col cols="12" md="6" v-if="showSearch2">
          <el-text-field
            :required="requiredSearch2"
            :key="search2Key"
            :label="search2"
            :tooltip="search2Tooltip"
            v-model="mainData[search2Field]"
          />
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import paieskaTurtasTipai from './paieskaTurtasTipai'

export default {
  name: 'PaieskaTurtas',
  props: {
    mainData: Object,
  },
  mixins: [paieskaTurtasTipai],
  $_veeValidate: {
    validator: '$validator',
  },
  computed: {
    isSearch1() {
      return this.search1 !== null
    },
    isSearch2() {
      return this.search2 !== null
    },
    search1Value() {
      return this.mainData && this.search1Field
        ? this.mainData[this.search1Field] ?? null
        : null
    },
    search2Value() {
      return this.mainData && this.search2Field
        ? this.mainData[this.search2Field] ?? null
        : null
    },
    showSearch1() {
      return this.search1 !== null
    },
    showSearch2() {
      return this.search2 !== null && !this.isIsrasasNtr
    },
    requiredSearch1() {
      return !this.isSearch2 || !this.search2Value
    },
    requiredSearch2() {
      return !this.isSearch1 || !this.search1Value
    },
    isIsrasasNtr() {
      return this.mainData.paslauga === 'israsas'
    },
    isVpb() {
      return (
        this.mainData.tur_rusis === 'dizainas' ||
        this.mainData.tur_rusis === 'prekes_zenklas'
      )
    },
  },
}
</script>
<style lang="scss" scoped></style>
